import { render, staticRenderFns } from "./ReaderAttributeFilters.vue?vue&type=template&id=bd4a945c&"
import script from "./ReaderAttributeFilters.vue?vue&type=script&lang=js&"
export * from "./ReaderAttributeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4a945c')) {
      api.createRecord('bd4a945c', component.options)
    } else {
      api.reload('bd4a945c', component.options)
    }
    module.hot.accept("./ReaderAttributeFilters.vue?vue&type=template&id=bd4a945c&", function () {
      api.rerender('bd4a945c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReaderAttributeFilters.vue"
export default component.exports